import React from 'react'
import { StyleSheet, View } from 'react-native'

const Card = props => {
    return (
        <View style={{...styles.card, ...props.style}}>{props.children}</View>
    )
}

export default Card

const styles = StyleSheet.create({
    card: {
        borderRadius: 15,
        backgroundColor: 'white',
        //borderColor: 'black',
        //borderWidth: 1.8,
        shadowColor: "rgba(0,0,0,0.15)",
        shadowOffset: {
            width: 1.5,
            height: 1.5
        },
        shadowRadius: 6,
        shadowOpacity: 1,
        elevation: 2
    }
})
